/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import ValidatePatternField from '../../../submission/templates/ValidatePatternField';
import { StyledTableCell } from './StyledTableCell';
import { ValidateActivationEvent } from '../../../submission/useValidatePatternField';

export function FeeBarcodeCell({ fee, feeSelected, disabled, uiSchema, onChange }) {
  return (
    <StyledTableCell>
      <ValidatePatternField
        name="barcode"
        id={`${fee.code}-barcode`}
        feeBarcode={feeSelected?.barcode}
        uiSchema={uiSchema}
        triggerEvent={ValidateActivationEvent.BLUR}
        formatValidationResult={uiSchema?.barcodeValidationResult}
        validationOrder={fee?.validationOrder}
        onChange={onChange}
        disabled={disabled}
        invalidErrorText="invalid.barcode"
        inputProps={{ maxLength: 24 }}
        externalValidation={{
          endpoint: `fees/validation/#barcode#?numExpediente=P0&tipoTasa=${fee.code}&codBarras=#barcode#&numClases=${feeSelected?.quantity}`,
          inputKey: '#barcode#',
        }}
      />
    </StyledTableCell>
  );
}
